module.exports = __webpack_public_path__ + "static/logo - jobs-9629681101c93036bf31b444251dcf4b.png";